import { Component, OnInit, Inject, Optional, TemplateRef, ComponentFactoryResolver, Output, EventEmitter, ChangeDetectorRef, Directive } from '@angular/core';
import { ClassroomService } from '../services/classroom.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Location, DatePipe } from '@angular/common';
import { AuthService } from 'src/app/core/services/auth.service';
import { SlugifyPipe } from '../../shared/pipes/slugify.pipe';
import { FormBuilder } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { RouteStateService } from '../services/route-state.service';
import { CommonFunctionsService } from '../services/common-functions.service';
import { StudentService } from '../services/student.service';
import { ParentService } from '../services/parent.service';
import { InstructorService } from '../services/instructor.service';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { ResultModel } from '../models/result.model';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { BsLocaleService, BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { trLocale } from 'ngx-bootstrap/locale';
import BsDefaultConfig from 'src/app/configs/bs-datepicker.config';
import { LessonService } from '../services/lesson.service';
import { TermService } from '../services/term.service';
import { ClassService } from '../services/class.service';
import { ClassLevelService } from '../services/class-level.service';
import { MajorService } from '../services/major.service';
import { CourseService } from '../services/course.service';
import { AddressService } from '../services/address.service';
import { SubjectService } from '../services/subject.service';
import { UserService } from '../services/user.service';
import { RoleService } from '../services/role.service';
import { StudentUserService } from '../services/student-user.service';
import { MediaService } from '../services/media.service';
import { InstructorUserService } from '../services/instructor-user.service';
import { QuestionService } from '../services/question.service';
import { AppointmentService } from '../services/appointment.service';
import { VirtualClassService } from '../services/virtual-class.service';
import { DashboardService } from '../services/dashboard.service';
import { PasswordService } from '../services/password.service';
import { AlanService } from '../services/alan.service';
import { ReportService } from '../services/report.service';
import { TenantService } from '../services/tenant.service';
import { ImportService } from '../services/import.service';
import { TimeTableService } from '../services/time-table.service';
import { ClassHandoverService } from '../services/class-handover.service';
import { AnnouncementService } from '../services/announcement.service';
import { NgxImageCompressService } from 'ngx-image-compress';
import { ExamService } from '../services/exam.service';
import { QuizService } from '../services/quiz.service';
import { DomSanitizer, Meta } from '@angular/platform-browser';
import { SafeboxService } from '../services/finance/safebox.service';
import { NoteService } from '../services/note.service';
import { TransactionService } from '../services/finance/transaction.service';
import { FinanceCategoryService } from '../services/finance/finance-category.service';
import { CategoryService } from '../services/finance/category.service';
import { InvoiceService } from '../services/finance/invoice.service';
import { CompanyService } from '../services/finance/company.service';
import { ConnectionService } from '../services/crm-service/connection.service';
import { ActivityService } from '../services/crm-service/activity.service';
import { ActivityCategoryService } from '../services/crm-service/activity-category.service';
import { CalendarService } from '../services/crm-service/calendar.service';
import { SurveyService } from '../services/survey/survey.service';
import { SurveyParticipantService } from '../services/survey/survey-participant.service';
import { TrainingService } from '../services/training.service';
import { DataStateService } from '../services/data-state.service';
import { SubClassService } from '../services/subclass.service';
import { AssessmentService } from '../services/assessment.service';
import { ExcelTemplateService } from '../services/survey/excel-template.service';
import { ReportCommentService } from '../services/survey/report-comment.service';


declare var cordova: any;

@Directive()
export abstract class BaseComponent implements OnInit {
  public apiBaseUrl = environment.apiBaseUrl;
  public id: string = '-1';
  dateOnlyOptions = { year: 'numeric', month: 'numeric', day: 'numeric' };
  dateOnlyOptions2 = { year: 'numeric', month: 'long', day: 'numeric' };
  dateOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  dateTimeOptions = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
  longDateTimeOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
  timeOptions = { hour: '2-digit', minute: '2-digit', hour12: false };

  isCordova: boolean = false;
  isCordovaPlatformAndroid: boolean = false;
  isCordovaPlatformiOS: boolean = false;

  bsDatepickerConfig: BsDatepickerConfig = BsDefaultConfig

  @Output('onResult')
  onResult: EventEmitter<ResultModel> = new EventEmitter<ResultModel>()

  @Output('onCancel')
  onCancel: EventEmitter<ResultModel> = new EventEmitter<ResultModel>()

  currentUserPhoto: string = null;

  constructor(
    @Optional() public authService: AuthService,
    @Optional() public addressService: AddressService,
    @Optional() public classroomService: ClassroomService,
    @Optional() public classService: ClassService,
    @Optional() public courseService: CourseService,
    @Optional() public examService: ExamService,
    @Optional() public quizService: QuizService,
    @Optional() public studentService: StudentService,
    @Optional() public studentUserService: StudentUserService,
    @Optional() public parentService: ParentService,
    @Optional() public instructorService: InstructorService,
    @Optional() public instructorUserService: InstructorUserService,
    @Optional() public questionService: QuestionService,
    @Optional() public lessonService: LessonService,
    @Optional() public termService: TermService,
    @Optional() public classLevelService: ClassLevelService,
    @Optional() public majorService: MajorService,
    @Optional() public commonFunctionsService: CommonFunctionsService,
    @Optional() public modalService: BsModalService,
    @Optional() public componentFactoryResolver: ComponentFactoryResolver,
    @Optional() public bsLocaleService: BsLocaleService,
    @Optional() public subjectService: SubjectService,
    @Optional() public userService: UserService,
    @Optional() public roleService: RoleService,
    @Optional() public mediaService: MediaService,
    @Optional() public assessmentService: AssessmentService,
    @Optional() public appointmentService: AppointmentService,
    @Optional() public virtualClassService: VirtualClassService,
    @Optional() public dashBoardService: DashboardService,
    @Optional() public passwordService: PasswordService,
    @Optional() public alanService: AlanService,
    @Optional() public reportService: ReportService,
    @Optional() public tenantService: TenantService,
    @Optional() public importService: ImportService,
    @Optional() public timeTableService: TimeTableService,
    @Optional() public calendarService: CalendarService,
    @Optional() public classHandoverService: ClassHandoverService,
    @Optional() public announcementService: AnnouncementService,
    @Optional() public safeboxService: SafeboxService,
    @Optional() public noteService: NoteService,
    @Optional() public transactionService: TransactionService,
    @Optional() public categoryService: CategoryService,
    @Optional() public financeCategoryService: FinanceCategoryService,
    @Optional() public invoiceService: InvoiceService,
    @Optional() public companyService: CompanyService,
    @Optional() public connectionService: ConnectionService,
    @Optional() public activityService: ActivityService,
    @Optional() public activityCategoryService: ActivityCategoryService,
    @Optional() public surveyService: SurveyService,
    @Optional() public surveyParticipantService: SurveyParticipantService,
    @Optional() public trainingService: TrainingService,
    @Optional() public subClassService: SubClassService,
    @Optional() public excelTemplateService: ExcelTemplateService,
    @Optional() public reportCommentService: ReportCommentService,

    public routeStateService: RouteStateService,

    public dataStateService: DataStateService,
    public changeDetector: ChangeDetectorRef,
    public route: ActivatedRoute,
    public router: Router,
    public location: Location,
    public slugifyPipe: SlugifyPipe,
    public datePipe: DatePipe,
    public fb: FormBuilder,
    public imageCompress: NgxImageCompressService,
    public metaService: Meta,
    public sanitizer:DomSanitizer

  ) {

    if (typeof (cordova) != "undefined") {
      this.isCordova = true;

      if (cordova.platformId === "ios")
        this.isCordovaPlatformiOS = true;
      else if (cordova.platformId === "android")
        this.isCordovaPlatformAndroid = true;

    }


    this.route.params.subscribe(params => this.id = params.id);

    this.routeStateService.UserPhoto.subscribe(photo => this.currentUserPhoto = photo);

    defineLocale('tr', trLocale);
    this.bsLocaleService.use('tr');
  }

  ngOnInit() {

  }

  getDateOnlyString(date: string | Date): string {
    //01.01.2021
    if (date == null || date == 'null' || date == '0' || date == '') {
      return '';
    }
    if (Object.prototype.toString.call(date) === "[object Date]") {
      return (date as Date).toLocaleDateString('tr-TR', this.dateOnlyOptions);
    }
    else {
      return new Date(date).toLocaleDateString('tr-TR', this.dateOnlyOptions);
    }
  }

  getDateOnlyString2(date: string | Date): string {
    //1 Ocak 2021
    if (date == null || date == 'null' || date == '0' || date == '') {
      return '';
    }
    if (Object.prototype.toString.call(date) === "[object Date]") {
      return (date as Date).toLocaleDateString('tr-TR', this.dateOnlyOptions2);
    }
    else {
      return new Date(date).toLocaleDateString('tr-TR', this.dateOnlyOptions2);
    }
  }

  getDateString(date: string | Date): string {
    //1 Ocak 2021 Cuma
    if (date == null || date == 'null' || date == '0' || date == '') {
      return '';
    }
    if (Object.prototype.toString.call(date) === "[object Date]") {
      return (date as Date).toLocaleDateString('tr-TR', this.dateOptions);
    }
    else {
      return new Date(date).toLocaleDateString('tr-TR', this.dateOptions);
    }
  }

  getDateTimeString(date: string | Date): string {
    //1 Ocak 2021 13:08
    if (date == null || date == 'null' || date == '0' || date == '') {
      return '';
    }
    if (Object.prototype.toString.call(date) === "[object Date]") {
      return (date as Date).toLocaleDateString('tr-TR', this.dateTimeOptions);
    }
    else {
      return new Date(date).toLocaleDateString('tr-TR', this.dateTimeOptions);
    }
  }

  getLongDateTimeString(date: string | Date): string {
    //1 Ocak 2021 Cuma 13:08
    if (date == null || date == 'null' || date == '0' || date == '') {
      return '';
    }
    if (Object.prototype.toString.call(date) === "[object Date]") {
      return (date as Date).toLocaleDateString('tr-TR', this.longDateTimeOptions);
    }
    else {
      return new Date(date).toLocaleDateString('tr-TR', this.longDateTimeOptions);
    }
  }

  getTimeString(date: string | Date): string {
    //13:08
    if (date == null || date == 'null' || date == '0' || date == '') {
      return '';
    }
    if (Object.prototype.toString.call(date) === "[object Date]") {
      return (date as Date).toLocaleTimeString('tr-TR', this.timeOptions);
    }
    else {
      return new Date(date).toLocaleTimeString('tr-TR', this.timeOptions);
    }
  }

  addMonths(date, value):Date {
    var d = new Date(date),
        n = date.getDate();
    d.setMonth(d.getMonth() + value);
    return d;
  }

  topScroll() {
    var elmnt = document.getElementById("target");
    elmnt.scrollIntoView({ behavior: 'smooth' });
  }

}
